'use client';

import { useEffect } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { useParticipant } from '@/lib/participant-auth/context';

export function DatadogIdentifyHub() {
  const participant = useParticipant();

  useEffect(() => {
    if (!datadogRum.getInitConfiguration()) return;

    if (!participant) {
      datadogRum.clearUser();
      return;
    }

    const fullName = [participant.firstName, participant.lastName]
      .filter(Boolean)
      .join(' ');
    const name = participant.displayName ?? (fullName.length > 0 ? fullName : undefined);

    datadogRum.setUser({
      id: participant.id,
      email: participant.email,
      name,
      username: participant.username ?? undefined,
      type: 'athlete',
    });
  }, [participant]);

  return null;
}
